import { store } from 'v3/data/store';
import { loadingSlice } from '.';

export const showLoading = () => {
  store.dispatch(loadingSlice.actions.showLoading());
};

export const hideLoading = () => {
  store.dispatch(loadingSlice.actions.hideLoading());
};

export const incrementLoadingCount = () => {
  store.dispatch(loadingSlice.actions.incrementLoadingCount());
};

export const decrementLoadingCount = () => {
  store.dispatch(loadingSlice.actions.decrementLoadingCount());
};
